<template>
  <a-layout-header :class="[headerTheme, 'admin-header']">
    <div :class="['admin-header-wide', layout, pageWidth]">
      <router-link v-if="isMobile || layout === 'head'" :to="filterTo()" :class="['logo', isMobile ? null : 'pc', headerTheme]">
        <img width="32" src="@/assets/img/title.png" />
        <h1 v-if="!isMobile">{{systemName}}</h1>
      </router-link>
      <a-divider v-if="isMobile" type="vertical" />
      <!-- <a-icon v-if="layout !== 'head'" class="trigger" :type="collapsed ? 'menu-unfold' : 'menu-fold'" @click="toggleCollapse"/> -->
      <div v-if="layout !== 'side' && !isMobile" class="admin-header-menu" :style="`width: ${menuWidth};`">
        <i-menu class="head-menu" :theme="headerTheme" mode="horizontal" :options="menuData" @select="onSelect"/>
      </div>
      <div class="admin-header-left">
        <!-- <h1 class="page-title">{{title}}</h1> -->
        <a-page-header
          v-if="!hiddenBack"
          :title="title"
          @back="() => $router.go(-1)"
        />
      </div>
      <a-alert
        v-if="showCreditTips"
        class="admin-header-center"
        closable
        show-icon
        :type="creditType"
        :after-close="onCloseTips"
      >
        <a-icon slot="icon" theme="filled" type="info-circle" />
        <marquee slot="message" style="width: 230px">
          {{creditMessage}}
        </marquee>
      </a-alert>

      <div :class="['admin-header-right', headerTheme]">
          <img v-if="!isHiddenMenu" v-track-click="{ trackName: '顶部导航栏-升级新版' }" class="tonew" src="@/assets/img/newUrl.gif" alt="进入新版" @click="toNew" />
          <header-avatar class="header-item" :account-list="accountList" :org-name-account-list="orgNameAccountList"  @onChange="onChange" @onSearch="onSearch" />
      </div>
    </div>
  </a-layout-header>
</template>

<script>
import IMenu from '@/components/menu/menu'
import {mapState, mapMutations, mapGetters} from 'vuex'
import { EventBus } from '@/utils/event-bus'
import { getCredit } from '@/api/layout'
import HeaderAvatar from './HeaderAvatar'
import env from '../../../env/index';

export default {
  name: 'AdminHeader',
  components: {IMenu, HeaderAvatar},
  // props: ['collapsed', 'menuData', 'accountList', 'orgNameAccountList'],
  props: {
    title: {
      type: [String, Boolean],
      required: false,
      default: ''
    },
    collapsed: {
      type: Boolean,
      default: false
    },
    menuData: {
      type: Array,
      default: () => ([]),
    },
    accountList: {
      type: Array,
      default: () => ([]),
    },
    orgNameAccountList: {
      type: Array,
      default: () => ([]),
    }
  },
  data() {
    return {
      langList: [
        {key: 'CN', name: '简体中文', alias: '简体'},
        {key: 'HK', name: '繁體中文', alias: '繁體'},
        {key: 'US', name: 'English', alias: 'English'}
      ],
      searchActive: false,
      showCreditTips: false,
      creditPercentage: 0,
      switchRatio: 0,
      isInWujie: false,
    }
  },
  computed: {
    ...mapState('setting', ['theme', 'isMobile', 'layout', 'systemName', 'lang', 'pageWidth']),
    ...mapGetters('iframe', ['isHiddenMenu']),
    headerTheme () {
      if (this.layout === 'side' && this.theme.mode === 'dark' && !this.isMobile) {
        return 'light'
      }
      return this.theme.mode
    },
    langAlias() {
      const lang = this.langList.find(item => item.key === this.lang)
      return lang.alias
    },
    menuWidth() {
      const {layout, searchActive} = this
      const headWidth = layout === 'head' ? '100% - 188px' : '100%'
      const extraWidth = searchActive ? '600px' : '400px'
      return `calc(${headWidth} - ${extraWidth})`
    },
    creditMessage() {
      let message = ''
      if (this.creditPercentage >= 100) {
        message = '截至昨天您的回款已逾期，暂无法提交订单，请尽快处理!'
      } else {
        message = `截止昨天不包括在途的授信余额已占用${this.creditPercentage}%,请您及时进行回款操作，否则将有可能影响正常下单`
      }
      return message
    },
    creditType() {
      let type = ''
      if (this.creditPercentage >= 100) {
        type = 'error'
      } else {
        type = 'warning'
      }
      return type
    },
    hiddenBack() {
      return this.isHiddenMenu && this.$route.hash === '#/order/createOrder'
    }
  },
  created(){
    // eslint-disable-next-line no-underscore-dangle
    this.isInWujie = window.__POWERED_BY_WUJIE__
    this.getShowCreditTips()
  },
  methods: {
    async getShowCreditTips() {
      const getCreditTips = sessionStorage.getItem('getCreditTips')
      let showCreditTips = sessionStorage.getItem('showCreditTips')
      let creditPercentage = sessionStorage.getItem('creditPercentage') || 0
      let switchRatio = sessionStorage.getItem('switchRatio')
      try {
        const {customerCode,tenantId, creditCode} = this.$store.state.user
        // creditCode存在时不请求授信预警
        if (creditCode) {
          showCreditTips = false
        } else if (!getCreditTips) {
          // 请求授信卡控
          const res = await getCredit({
            tenantId,
            customerCode
          })
          showCreditTips = res.warning
          creditPercentage = ((res.proportion || 0)*100).toFixed()
          switchRatio = ((res.switchRatio || 0)*100).toFixed()
        }
      } finally {
        sessionStorage.setItem('getCreditTips', true)
        sessionStorage.setItem('showCreditTips', showCreditTips || '')
        sessionStorage.setItem('creditPercentage', creditPercentage)
        sessionStorage.setItem('switchRatio', switchRatio)
        this.showCreditTips = showCreditTips
        this.creditPercentage = creditPercentage
        this.switchRatio = switchRatio
      }
    },
    onCloseTips() {
      this.showCreditTips = false
      sessionStorage.setItem('showCreditTips', '')
    },
    filterTo(){
      if(!this.$store.state.user.customerId){
        return '/authentication'
      }
      return '/'
    },
    onChange(company){
      this.$emit('onChange',company)
    },
    onSearch(value){
      this.$emit('onSearch', value)
    },
    toggleCollapse () {
      this.$emit('toggleCollapse')
      EventBus.$emit('onshrink', !this.collapsed)
    },
    onSelect (obj) {
      this.$emit('menuSelect', obj)
    },
    toNew() {
      window.open(env.NEW_SYSTEM_URL);
    },
    ...mapMutations('setting', ['setLang'])
  }
}
</script>

<style lang="less" scoped>
@import "index";
.tonew {
  height: 32px;
  margin-right: 12px;
  cursor: pointer;
}
</style>
